import ReinforcementRepository from '../../domain/repositories/ReinforcementRepository';
import ReinforcementDataStoreFactory from '../factories/ReinforcementDataStoreFactory';
import ReinforcementDataStore from '../datastores/ReinforcementDataStore';

export default class ReinforcementDataRepository
  implements ReinforcementRepository
{
  getReinforcements() {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.getReinforcements();
  }

  getCoursesWithReinforcements() {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.getCoursesWithReinforcements();
  }

  getReinforcementsByCourse(courseId: string) {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.getReinforcementsByCourse(courseId);
  }

  getDetailReinforcementById(idReinforcement: string) {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.getDetailReinforcementById(idReinforcement);
  }

  subscribeReinforcements(reinforcementId: number) {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.subscribeReinforcements(reinforcementId);
  }

  unsubscribeReinforcements(code: string) {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.unsubscribeReinforcements(code);
  }

  subscribeToWaitingList(parameters: any) {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.subscribeToWaitingList(parameters);
  }

  unsubscribeToWaitingList(parameters: any) {
    const reinforcementDataStore: ReinforcementDataStore =
      ReinforcementDataStoreFactory.create();
    return reinforcementDataStore.unsubscribeToWaitingList(parameters);
  }
}
